import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { changeNumberColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getChangeNumber } from "../../../../api/sim";

const COPY_KEYS = ["id", "old_msisdn", "new_msisdn", "status", "created_at", "last_updated"];

const TmobilejChangeNumberBatch = () => (
  <BatchDetail
    title="Change Number"
    apiGet={__getChangeNumber}
    client={CLIENTS.tmobilej}
    columnsFactory={changeNumberColumns}
    copyKeys={COPY_KEYS}
    exportAction="change_number"
    retryOperation="change_number"
    showTerminate
    getRowPath={(row) => `/tmobilej/change_number/${row.id}`}
  />
);

export default TmobilejChangeNumberBatch;
